import { Button } from "@govlaunch/core";
import * as palette from "@govlaunch/palette";
import React from "react";
import { FormattedMessage } from "react-intl";
import mediaQueries from "~/components/mediaQueries";

interface IAreYouSureProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export default function AreYouSure({ onConfirm, onCancel }: IAreYouSureProps) {
  return (
    <div
      css={{
        display: "grid",
        gridRowGap: 20,
        padding: 20,
        backgroundColor: palette.white,
        border: `solid 1px ${palette.lightestGray}`,
        borderRadius: 4,
      }}
    >
      <div
        css={{
          display: "grid",
          gridRowGap: 4,
        }}
      >
        <h2
          css={{
            margin: 0,
          }}
        >
          <FormattedMessage defaultMessage="Are you sure?" id="2oCaym" />
        </h2>

        <p
          css={{
            margin: 0,
            color: palette.mediumGray,
            fontSize: 14,
            lineHeight: 1.33,
          }}
        >
          <FormattedMessage
            defaultMessage="WARNING: By downgrading your account, you will no longer have access to the following features:"
            id="inGgC8"
          />
        </p>
      </div>

      <ul
        css={{
          color: palette.red,
        }}
      >
        <li>
          <FormattedMessage defaultMessage="Enhanced product profiles" id="zgVDfq" />
        </li>
        <li>
          <FormattedMessage defaultMessage="Increased visibility for your products across our platform" id="x+uUzO" />
        </li>
        <li>
          <FormattedMessage defaultMessage="Team access" id="mBumrs" />
        </li>
        <li>
          <FormattedMessage defaultMessage="Custom branded discussion groups" id="SvUL59" />
        </li>
        <li>
          <FormattedMessage defaultMessage="Access to community discussions" id="tTYN1/" />
        </li>
        <li>
          <FormattedMessage defaultMessage="Customizable public share page" id="+PonEv" />
        </li>
      </ul>

      <div
        css={mediaQueries({
          justifyContent: "center",
          display: "grid",
          gridTemplateColumns: ["1fr", "1fr", "1fr", "1fr 1fr"],
          gridColumnGap: 20,
          gridRowGap: 20,
        })}
      >
        <Button color={palette.innovatorBlue} onClick={onConfirm}>
          <FormattedMessage defaultMessage="Yes, proceed" id="mti4GD" />
        </Button>

        <Button color={palette.darkGray} theme="secondary" onClick={onCancel}>
          <FormattedMessage defaultMessage="Cancel" id="47FYwb" />
        </Button>
      </div>
    </div>
  );
}
